import { SYNC_KEY_COSTOS_AGRICULTURA } from "../../../constantes";
import { CostosPlataformaService, TarifaDataAgItem } from "../../generated/grpc/plataforma_costos_pb";
import { CostoAgriculturaResponse } from "../../response/costos/CostoAgriculturaResponse";
import { ServiceGetListBase } from "../base/ServiceGetListBase";
import { grpcCall, grpcClient } from "../grpc/grpcCall";

/** Tramos de DATA AG agricultura (`CostosPlataformaService`, gRPC). Pipeline los reusa para cotizar. */
export class CostoAgriculturaListService extends ServiceGetListBase<CostoAgriculturaResponse> {
  static readonly instance = new CostoAgriculturaListService();
  private constructor() { super(); }

  /** Clave única del listado: deduplica `sync()` (dos pedidos simultáneos, un solo request). */
  protected readonly syncKey = SYNC_KEY_COSTOS_AGRICULTURA;

  /** gRPC-Web (`ListAgricultura`): no eliminados, por orden. */
  protected async fetchItems(): Promise<CostoAgriculturaResponse[]> {
    const r = await grpcCall(() => grpcClient(CostosPlataformaService).listAgricultura({}));
    return r.items.map(toCostoAgriculturaResponse);
  }
}

/** Mensaje gRPC del tramo → respuesta. Sin precio = negociación directa. */
export function toCostoAgriculturaResponse(t: TarifaDataAgItem): CostoAgriculturaResponse {
  const precioAnual = t.precioAnual !== undefined ? Number(t.precioAnual) : null;
  return {
    id: t.id,
    isEliminado: false,
    rango: t.rango,
    topeMaximoHa: t.topeMaximoHa ?? null,
    precioAnual,
    isNegociacion: precioAnual === null,
    orden: t.orden,
  };
}
